import Link from 'next/link';
import React from 'react';
import { IRoute, routes } from '../../routes';

interface BreadcrumbProps {
  routesHistory: Partial<IRoute>[];
}

function Breadcrumb({ routesHistory = [] }: BreadcrumbProps) {
  const [fullRoutes, setFullRoutes] = React.useState<Partial<IRoute>[]>([]);
  const [icon, setIcon] = React.useState(null);

  // get first route from routes to get the icon
  React.useEffect(() => {
    const firstRoute = routes.find((route) =>
      routesHistory[0]?.href.includes(route.href)
    );
    setIcon(firstRoute?.icon);

    const currentRoutes = [...routesHistory];

    const newFullRoutes = [...currentRoutes];
    setFullRoutes(newFullRoutes);
  }, [routesHistory]);

  return (
    <ul className="flex items-center ">
      {fullRoutes?.map(
        (route, i) =>
          route && (
            <li
              className="flex items-center  "
              key={`${route.href}-${i}-${route?.text}`}
            >
              <div className="flex justify-center items-center">
                {i === 0 ? (
                  <>
                    <div className="w-3 h-3 text-neutral-warm-500 flex justify-center items-center">
                      {icon}
                    </div>
                    <span className="w-5 h-3 text-neutral-warm-500 flex justify-center items-center">
                      /
                    </span>

                    {!route.isCollapsible ? (
                      <Link href={route.href}>
                        <span
                          className={`font-medium my-auto    ${
                            i === (routesHistory?.length ?? 0) - 1
                              ? 'text-gray-300'
                              : 'text-neutral-warm-500 '
                          }`}
                        >
                          {route.text}
                        </span>
                      </Link>
                    ) : null}
                  </>
                ) : (
                  <Link href={route.href}>
                    <span
                      className={`font-medium    ${
                        i === (routesHistory?.length ?? 0) - 1
                          ? 'text-gray-300'
                          : 'text-neutral-warm-500 '
                      }`}
                    >
                      {route.text}
                    </span>
                  </Link>
                )}
              </div>
              <span
                className={`text-neutral-warm-500 mx-1 ${
                  i === (routesHistory?.length ?? 0) - 1 ? 'hidden' : ''
                }`}
              >
                /
              </span>
            </li>
          )
      )}
    </ul>
  );
}

export default Breadcrumb;
